import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Call_Api from "../Handileapi/Call_api";
import { path } from "../../routes/Paths";
import { GetWebAccessToken } from "../../components/ReusebleComponents/ResuseableApiCalls";
import { StoreUser } from "../../redux/slice/userDetailsSlice";

const useUserData = () => {
  const [userData, setUserDetails] = useState(null);
  const [userName, setUserName] = useState("");
  const [userImage, setUserImage] = useState("");
  const dispatch = useDispatch();

  const getUserDetails = async () => {
    const phNo = await localStorage.getItem("dummyUserPhoneNo");
    const dummyToken = "NTAR_DUMMY";
    const dummyToken2 = "NTAR_TEST";
    if (phNo == "9999999999") {
      const response = await Call_Api(
        path.GET_USER_DETAILS,
        "GET",
        {},
        dummyToken
      );

      if (response?.success && response?.response?.success) {
        setUserDetails(response?.response?.details);
        setUserName(response?.response?.details?.userName);
        setUserImage(response?.response?.details?.userimage);
        dispatch(StoreUser(response?.response?.details));
        localStorage.setItem("tokenDummy", dummyToken);
        return;
      } else {
        setUserDetails({});
        setUserName("");
        setUserImage("");
        dispatch(StoreUser({}));
        return;
      }
    } else if (phNo == "1122334455") {
      const response = await Call_Api(
        path.GET_USER_DETAILS,
        "GET",
        {},
        dummyToken2
      );

      if (response?.success && response?.response?.success) {
        setUserDetails(response?.response?.details);
        setUserName(response?.response?.details?.userName);
        setUserImage(response?.response?.details?.userimage);
        dispatch(StoreUser(response?.response?.details));
        localStorage.setItem("tokenDummy", dummyToken2);
        return;
      } else {
        setUserDetails({});
        setUserName("");
        setUserImage("");
        dispatch(StoreUser({}));
        return;
      }
    }  else {
      const token = await GetWebAccessToken();
      try {
        const response = await Call_Api(
          path.GET_USER_DETAILS,
          "GET",
          {},
          token
        );

        if (response?.success && response?.response?.success) {
          setUserDetails(response?.response?.details);
          setUserName(response?.response?.details?.userName);
          setUserImage(response?.response?.details?.userimage);
          dispatch(StoreUser(response?.response?.details));
          return response?.response?.details;
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    if (!userData || Object.keys(userData).length === 0) {
      getUserDetails();
    }
  }, [userData]);

  return { userData, userName, userImage, getUserDetails };
};

export default useUserData;
